import React from 'react';
import { ContentParagraph } from '../../../_lib/components/ContentParagraph';
import { Strong } from '../../../components/atoms/Strong/Strong';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Trans } from 'react-i18next';
import i18n from 'i18next';
import { DateFormat, DateFormats } from '../../../_lib/components/DateFormat';
import { PagePublicationInfoText } from '../../../_lib/components/PagePublicationInfo/partials/PagePublicationInfoText';
import { Dfn } from '../../../_lib/components/Dfn/Dfn';

type PageArchivedInfoTextProps = {
  archivedDate: string;
};

export function PageArchivedInfoText({ archivedDate }: PageArchivedInfoTextProps) {
  const { t } = useSonTranslation('PageArchivedInfo');

  return (
    <PagePublicationInfoText>
      <ContentParagraph>
        <Dfn>
          <Strong modifier="font-color-red">{t('glossary:instruction')}: </Strong>
        </Dfn>
        <Trans
          i18nKey="PageArchivedInfo:hint"
          i18n={i18n}
          components={[<DateFormat key={archivedDate} date={archivedDate} format={DateFormats.DATE} />]}
        />
      </ContentParagraph>
    </PagePublicationInfoText>
  );
}
